import { render, staticRenderFns } from "./station-bar.vue?vue&type=template&id=3bb284dd&scoped=true&"
import script from "./station-bar.vue?vue&type=script&lang=js&"
export * from "./station-bar.vue?vue&type=script&lang=js&"
import style0 from "./station-bar.vue?vue&type=style&index=0&id=3bb284dd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb284dd",
  null
  
)

export default component.exports